// icons
import { MdOutlineDashboard } from "react-icons/md";

const dashboard = {
    id: 'dashboard-group',
    type: 'group',
    roles: [1,100,110,200,300,400,500],
    breadcrumbs: false,
    children: [
      {
        id: 'dashboard',
        title: "Dashboard",
        type: 'item',
        breadcrumbs: false,
        icon: MdOutlineDashboard,
        url: '/'
      }
    ]
  };

export default dashboard;
